module.exports = __webpack_public_path__ + "img/duniter.png";